import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { EmployeeDetails } from "../employee-details/employee-details.entity";
import { Projects } from '../projects/projects.entity';
@Entity('project_mapping')
// @Index("fk_project_id", ["projectId",])
export class ProjectMapping {
    @PrimaryGeneratedColumn("increment", { name: 'id' })
    Id: number;
    @Column("int", {
        nullable: false,
        name: "cost_center_id"
    })
    costCenterId: number;
    @Column("int", {
        nullable: false,
        name: "project_id"
    })
    projectId: number;
    // @Column("boolean",{
    //     nullable:false,
    //     default:true,
    //     name:"status"
    //     })
    //   status:boolean;
    @Column("int", {
        nullable: false,
        name: "emp_id"
    })
    empId: number;
    @Column("boolean", {
        nullable: false,
        default:true,
        name: "atten_eligibility"
    })
    attenEligibility: boolean;
    @Column("date", {
        nullable: true,
        name: "assigned_date"
    })
    assignedDate: Date;
    @Column("date", {
        nullable: true,
        name: "unassigned_date"
    })
    unassignedDate: Date;
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    
    @Column("int", {
        nullable: true,
        name: "created_user"
    })
    createdUser: number | null;
    createdAt: Date;
    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;
    @Column("int", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: number | null;
    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @ManyToOne(type=>EmployeeDetails, employeeDetails=>employeeDetails.projectMappingInfo,{  nullable:false, })
    @JoinColumn({ name:"emp_id"})
    projectMappingInfo: EmployeeDetails;
    

    // @ManyToOne(type=>Projects, projects=>projects.projectId,{  nullable:false, })
    // @JoinColumn({ name:"project_id"})
    // projectId: Projects | null;

    @ManyToOne(type => Projects, project => project.projectMapping)
    projectsInfo: Projects;
}
